// src/pages/Profile.jsx
import React, { useEffect, useMemo, useState } from "react";
import Header from "../components/shared/Header";
import ChangePasswordForm from "../components/profile/ChangePasswordForm";
import { api } from "../services/api";

// Helper seguro para leer string de storage
function read(key) {
  try {
    return (
      (typeof localStorage !== "undefined" && localStorage.getItem(key)) ||
      (typeof sessionStorage !== "undefined" && sessionStorage.getItem(key)) ||
      null
    );
  } catch {
    return null;
  }
}

export default function Profile({ session, onLogout }) {
  // --------- Datos de sesión base ----------
  const token = session?.token || read("token") || null;
  const user = session?.user || read("user"); // puede ser objeto o string

  // Normaliza a objeto si es posible
  const userObj = typeof user === "object" && user ? user : {};
  const emailFromUser =
    (typeof user === "object" && user?.email) || (typeof user === "string" ? user : null);

  // --------- /auth/me para completar brand/company si faltan ----------
  const [me, setMe] = useState(null);

  useEffect(() => {
    let cancel = false;
    async function loadMe() {
      // Si ya tenemos brand/company, no pedimos nada
      if (userObj?.brand_dir && userObj?.company_name) return;
      if (!token) return;
      try {
        const data = await api.get("/auth/me", token);
        if (!cancel && data?.user) setMe(data.user);
      } catch {
        // fallback opcional a /me si existe
        try {
          if (cancel) return;
          const data2 = await api.get("/me", token);
          if (!cancel && data2?.user) setMe(data2.user);
        } catch {
          /* noop */
        }
      }
    }
    loadMe();
    return () => {
      cancel = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, userObj?.brand_dir, userObj?.company_name]);

  // Valores efectivos para el Header (mismo patrón que AdminPanel)
  const brandForHeader = userObj?.brand_dir || me?.brand_dir || null;
  const companyForHeader = userObj?.company_name || me?.company_name || null;

  // Email para la “pill” de la derecha
  const emailFromStorage = useMemo(() => read("user"), []);
  const email =
    emailFromUser ||
    (emailFromStorage && (() => {
      try {
        const parsed = JSON.parse(emailFromStorage);
        return parsed?.email || emailFromStorage;
      } catch {
        return emailFromStorage;
      }
    })()) ||
    null;

  return (
    <div
      className="min-h-screen relative"
      style={{
        backgroundImage: "url('/fondo.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-black/10 to-transparent" />

      {/* Header ya compatible con Admin/Empleado: brandDir + companyName */}
      <Header
        usuario={email || user}
        brandDir={brandForHeader}
        companyName={companyForHeader}
        onLogout={onLogout}
        showBack
        subtitle="Mi perfil"
      />

      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="sr-only">Mi perfil</h1>

        {!email && (
          <div className="mt-6 rounded-xl border bg-white/70 p-3 text-sm text-slate-700">
            No hemos podido identificar tu correo. Intenta volver a iniciar sesión.
          </div>
        )}

        <section className="min-h-[70vh] grid place-items-start md:place-items-center py-8 sm:py-10">
          <div className="relative w-full max-w-xl">
            <div
              aria-hidden="true"
              className="pointer-events-none absolute -inset-8 rounded-[32px] blur-3xl opacity-60"
              style={{
                background:
                  "radial-gradient(120px 120px at 20% 10%, rgba(0,75,135,.12), transparent 60%), radial-gradient(160px 160px at 90% 20%, rgba(56,189,248,.10), transparent 60%)",
              }}
            />
            <ChangePasswordForm />
          </div>
        </section>
      </main>
    </div>
  );
}
